import React from 'react';
import { API_BASE_URL } from '../../helpers/ApiSettings';

const WorkshopTable = ({ workshops, onEdit, onDelete }) => {
  return (
    <div className="table-responsive">
      <table className="table">
        <thead>
          <tr>
            <th>Image</th>
            <th>Titre</th>
            <th>Référence</th>
            <th>Catégorie</th>
            <th>Lieu</th>
            <th>Prix (€)</th>
            <th>Durée</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {workshops.map((workshop) => (
            <tr key={workshop.id}>
              <td>
                {workshop.image ? (
                  <img
                    src={`${API_BASE_URL}${workshop.image.url}`}
                    alt={workshop.title}
                    style={{ width: '50px', height: '50px', objectFit: 'cover' }}
                  />
                ) : (
                  <div className="bg-secondary" style={{ width: '50px', height: '50px' }}></div>
                )}
              </td>
              <td>{workshop.title}</td>
              <td>{workshop.reference}</td>
              <td>{workshop.category?.name}</td>
              <td>{workshop.location}</td>
              <td>{workshop.price}€</td>
              <td>{workshop.duration}min</td>
              <td>
                <div className="btn-group">
                  <button
                    className="btn btn-sm btn-info me-2"
                    onClick={() => onEdit(workshop)}
                    // data-bs-toggle="modal"
                    // data-bs-target="#editWorkshopModal"
                  >
                    Modifier
                  </button>
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() => onDelete(workshop.documentId)}
                  >
                    Supprimer
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default WorkshopTable;